import pSelect from "./select";

new pSelect('#p-select');


// WEBPACK FOOTER //
// ./src/js/index.js